import React from 'react';

const colors = {
  Preheat: { bg: '#92400e', text: '#fef3c7', label: 'วอร์มอัพ (Preheat)' },
  Ready:   { bg: '#14532d', text: '#bbf7d0', label: 'พร้อม (Ready)' },
  Offline: { bg: '#1e293b', text: '#94a3b8', label: 'ออฟไลน์ (Offline)' },
};

export default function StatusBadge({ status }) {
  const cfg = colors[status] || colors.Offline;
  return (
    <span style={{
      background: cfg.bg, color: cfg.text,
      padding: '4px 14px', borderRadius: 20,
      fontSize: 13, fontWeight: 600, letterSpacing: 0.5,
    }}>
      {cfg.label}
    </span>
  );
}
